export const BASE_ENTITY_FIELDS = `
id
removed
dataScope
version
`;
